<template>
  <v-card>
    <v-card-title>
      <span> Оценка инновационности </span>
      <v-spacer></v-spacer>
      <v-btn icon @click.stop="close"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text :style="maxHeightStyle">
      <the-score-chart></the-score-chart>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-on:click="close" color="blue darken-1" text> Закрыть </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import TheScoreChart from "./TheScoreChart.vue";

export default {
  name: "TheScoreCard",
  components: { TheScoreChart },
  props: {
    fullscreen: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    maxHeightStyle() {
      if (this.fullscreen) return "";
      return "max-height: 700px;";
    },
  },
  methods: {
    close() {
      this.$emit("close-dialog");
    },
  },
};
</script>
